// extracted by mini-css-extract-plugin
export var buttonWrapper = "styles-module--buttonWrapper--91721";
export var textWrapper = "styles-module--textWrapper--3482e";
export var title = "styles-module--title--11726";